window.recaclulatePerfectScrollbarHeight = () => {
  Array.from(
    document?.getElementsByClassName(
      "scrollbar-container scrollbar-recaclulate"
    )
  ).forEach((el, elidx) => {
    el.style.height = (window.innerHeight - el.getBoundingClientRect().top - 8)
      .toString()
      .concat("px");
  });
};

window.recaclulateResultsPanelHeight = () => {
  document.getElementById("resizable-results-panel").style.height =
    "calc(100vh - 22rem)";
};

window.showLeftPanel = () => {
  document.getElementById("menu-offcanvas-id").style.display = "block";
};

window.hideLeftPanel = () => {
  document.getElementById("menu-offcanvas-id").style.display = "none";
};
